import { Helmet } from "react-helmet-async";

const BASE = "https://duruvault.com";
const DEFAULT_OG = `${BASE}/og-image.jpg`;
const DEFAULT_TITLE = "DuruVault — Your Important Documents. One Secure Vault.";

// Per-route SEO: unique title, description, canonical and social-sharing tags.
export default function Seo({ title, description, path = "/", image = DEFAULT_OG, noindex = false }) {
  const url = `${BASE}${path}`;
  const full = title ? `${title} · DuruVault` : DEFAULT_TITLE;
  return (
    <Helmet prioritizeSeoTags>
      <title>{full}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="DuruVault" />
      <meta property="og:title" content={full} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={full} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
